export default __webpack_public_path__ + "static/media/IMG_0459.17ab7242.17ab7242.JPG";